import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';
import { NotFound } from './NotFound';

function Throw({ error }: { error: unknown }): never {
  throw error instanceof Error ? error : new Error(String(error));
}

/** `errorElement` del enrutador: un 404 del router muestra «No encontramos esa página»; el resto, la pantalla de error. */
export function RootError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFound />;
  return (
    <ErrorBoundary fullPage>
      <Throw error={error} />
    </ErrorBoundary>
  );
}
